import { Component, ViewChild, effect, inject } from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';
import {
  vesselsEvents,
  vesselSpecEvents,
  VesselSpecStore,
  VesselsStore,
} from '@navstation-portal/vessels/data-access/store';
import { injectDispatch } from '@ngrx/signals/events';
import { AuthStore } from '@navstation-portal/shared/data-access/auth';
import { AppStore } from '@navstation-portal/reporting/data-access/app';
import { SpinnerComponent } from '@navstation-portal/shared/ui/components';
import { VesselSelectorContentComponent } from './vessel-selector-content/vessel-selector-content.component';

@Component({
  selector: 're-vessel-selector',
  templateUrl: './vessel-selector.component.html',
  styleUrl: './vessel-selector.component.css',
  imports: [PopoverModule, VesselSelectorContentComponent, SpinnerComponent],
})
export class VesselSelectorComponent {
  @ViewChild('vesselList') vesselList: Popover | undefined = undefined;

  readonly vesselsStore = inject(VesselsStore);
  readonly appStore = inject(AppStore);
  readonly authStore = inject(AuthStore);
  readonly vesselSpecStore = inject(VesselSpecStore);
  readonly vesselSpecDispatch = injectDispatch(vesselSpecEvents);
  readonly vesselsDispatch = injectDispatch(vesselsEvents);

  constructor() {
    const vessels = this.vesselsStore.vessels();
    const email = this.authStore.email();
    if (!vessels?.length && email) {
      this.vesselsDispatch.fetchVessels(email);
    }

    effect(() => {
      const selectedVesselId = this.appStore.selectedVesselId();
      const vesselSpecId = this.vesselSpecStore.vesselSpec()?._id?.$oid;
      if (selectedVesselId && selectedVesselId !== vesselSpecId) {
        this.vesselSpecDispatch.fetchVesselSpec(selectedVesselId);
      }
    });

    effect(() => {
      if (!this.appStore.selectedVessel() || !this.vesselList) return;

      this.vesselList.hide();
    });
  }

  isShowing = false;

  onShow = () => (this.isShowing = true);

  onHide = () => (this.isShowing = false);
}
